import styled from 'styled-components';

const getBgColor = (props) => {
	const { screenViewport, layout, background, loading } = props;
	if (loading) {
		return 'transparent';
	}

	if (screenViewport === 'mobile') {
		return 'transparent';
	}

	if ((screenViewport === 'mobile') && layout === 'single') {
		return background;
	}
	
	if (layout === 'auto') {
		return background;
	}
	return 'transparent';
};

const getRestStyles = (props) => {
	const { isIe, screenViewport } = props;
	if (isIe) {
		return `
			position: relative;
			margin-bottom: -100px;
		`;
	}
	if (screenViewport === 'mobile') {
		return `
			position: relative;
			height: 75px;
		`;
	}
	return `
		position: fixed;
		height: 100px;
	`;
}

const HeaderWrapper = styled.div`
	background: ${(props) => getBgColor(props)};
	display: flex;
	width: 100%;
	opacity: ${({ fade }) => (fade ? '0' : '1')};
	transition: opacity 0.3s ease-in-out;
	pointer-events: ${({ fade }) => (fade ? 'none' : 'all')};
	z-index: ${({ fade }) => (fade ? '99' : '101')};
	${(props) => getRestStyles(props)};
`;

const Logo = styled.div`
	margin-top: ${({ screenViewport }) => screenViewport === 'mobile' ? '20px' : '35px'};
	margin-left: ${({ screenViewport }) => screenViewport === 'mobile' ? '16px' : '28px'};
	img {
		max-width: ${({ screenViewport }) => screenViewport === 'mobile' ? '110px' : '119px'};
		height: auto;
	}
	flex-grow: 1;
`;

const Links = styled.div`
	flex-grow: 3;
`;

const ButtonWrapper = styled.div`
	position: fixed;
	right: 20px;
	top: 20px;
	display: flex;
	align-items: center;
	margin: 8px 15px;
	z-index: 110;
	& > button {
		font-weight: bold;
		background-color: white;
	}
`;

export { HeaderWrapper, Logo, Links, ButtonWrapper };
